<template>
  <inventoryCategoriesList/>
</template>
<script>
import inventoryCategoriesList from '@/components/modules/inventory/products/subcategories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/subcategories/list.vue